<template>
  <div>
    <div class="d-flex justify-content-between my-3">
        <label class="align-self-center w-50 text-right" :class="{'error-message': creditLineRequiredBool}"> Credit Line (Required)</label>
        <div class="select-wrapper">
            <select v-model="brand" @change="emitBrand()" :style="creditLineRequiredBool ? 'border-color:red': ''">
                <option :disabled="true">
                  <span >Select a credit line</span>
                </option>
                <option  :value="brand" v-for="(brand, index) in brands" :key="index">
                  <span v-if="brand._id">{{ brand.name }}</span>
                </option>
            </select>
        </div>
    </div>
    <div v-if="brands[0] && brands[0].credit" class="d-flex justify-content-between my-3">
        <label class="align-self-center w-50 text-right"> Available Credit </label>
        <div :class="brand && brand.credit != null ? 'text-right' : 'text-center'" style="min-width: 100px;">
          <span v-if="brand && brand.credit != null"> £{{ brand.credit | priceformat }} </span>
          <span v-else> - </span>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
      return {
        brand: -1,
      }
    },
  props: ['brands', 'creditLineRequiredBool'],
  methods:{
    emitBrand(){
      this.$emit("emitBrand", this.brand);
    }
  }
}
</script>